import { createClient } from "@supabase/supabase-js";
import { supabase, tableName } from "../config/index_supabase.js";
import {userUUID } from "../constants/constant.js";
import { useState} from "react";
import { data } from "autoprefixer";
import { indLabel, nonIndLabel } from "../constants.js";

// const supabase = createClient("https://zcvtgtaimnsrlemslypr.supabase.co", process.env.REACT_APP_SUPABASE_ANON_KEY);
export const GetData = async () => {
  const [materialdata, setMaterialData] = useState([]);
  try {
    const { data, error } = await supabase
      .from(process.env.REACT_APP_SUPABASE_TABLE_NAME)
      .select()
      .eq("user_id", userUUID)
      .order("buy_date", { ascending: true });

    if (error) throw error;
    // Process and transform data here...
    let totalPercentageRate = 0.001 + 0.0000325 + 0.00000001 + 0.18 * (0.0000325 + 0.00000001) + 0.00015;
    const transformedDataForMaterialTable = data.map((item) => ({
      stockSymbol: item.stock_name,
      buyPrice: item.buy_price,
      buyDate: item.buy_date ? new Date(item.buy_date).toLocaleDateString() : '',
      quantity: item.quantity,
      sellPrice: item.sell_price,
      sellDate: item.sell_date ? new Date(item.sell_date).toLocaleDateString() : '',
      brokerage: item.brokerage,
      daysHold: item.days_hold,
      reasonToBuy: item.reason_to_buy,
      gttEnabled: item.gtt_enabled ? 'Yes' : 'No',
      profitLoss: item.profit_loss,
      returnPercent: item.return_percent,
      annualROI: item.annual_roi,
      id: item.id,
      amountInvested: item.amount_invested,
    }));
    setMaterialData(transformedDataForMaterialTable);
    return { materialdata}
  } catch (error) {
  }
};

export const getFeatureData = async (userId) => {
  try {
      const { data, error } = await supabase
      .from("user_settings")
      .select()
      .eq("user_id", userId)
      .single();

      if (error) throw error;

      const date = new Date().toString();

      // Map new user_settings fields to old features format for compatibility
      const features = {
        p_status: data.premium_status === 'premium', // Convert 'premium'/'free' to boolean
        insight_c: data.ai_insights_count || 0,
        user_id: data.user_id,
        loc: date.includes("530") ? indLabel : nonIndLabel
      }

      return features;
    } catch (error) {
      console.error('Error fetching user settings:', error);
      // Return default values if user_settings doesn't exist yet
      return {
        p_status: false,
        insight_c: 0,
        user_id: userId,
        loc: new Date().toString().includes("530") ? indLabel : nonIndLabel
      };
    }
};
